// extracted by mini-css-extract-plugin
export var inputContainer = "_jg-0";